import React from 'react'
import { defPath } from '../../config/defPath'
import { type CartProduct, useCartStore } from '../../hooks/useCartStore'

export const ProductCard = ({data}: {data: CartProduct}) => {

    const addToCart = useCartStore(state => state.addToCart)
    const openCart = useCartStore(state => state.openCart)

    const handleClick = () => {
        const item = {
            ...data,
            quantity: 1,
            precio: Number(data.precio),
        }
        addToCart(item)
        openCart()

        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': `${data.name}_product-tada`,
            'interaction':'true',
            'component_name': 'Modo_Carrera_Tada',
            'element_text': `${data.name}`,
            'product': `${data.name}`,
            'sku': `${data.sku}`,
        });
    }

    return (
        <div className="ar__productCard" data-sku={data.sku}>
            <div className="ar__productCard__img">
                <img src={data.img} alt={data.name} />
            </div>
            <div className="ar__productCard__info">
                <h2 className="ar__productCard__info__title">{data.name}</h2>
                <p className="ar__productCard__info__desc">{data.descr}</p>
                <p className="ar__productCard__info__price">
                    $ {Number(data.precio).toLocaleString('es-CO')}
                    <span className='ar__productCard__info__desc'>{data.precio_cantidad}</span>
                </p>
                <button className="ar__productCard__info__btn" onClick={handleClick}>AGREGAR</button>
            </div>
        </div>
    )
}
